import React from 'react';

const FillArrowIcon = props => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="33"
    height="19"
    viewBox="0 0 33 19"
  >
    <g fillRule="evenodd">
      <path
        d="M14.911 17.594L1.405 4.084a2.255 2.255 0 0 1 0-3.178 2.253 2.253 0 0 1 3.178 0L16.5 12.826 28.417.906a2.253 2.253 0 0 1 3.178 0 2.255 2.255 0 0 1 0 3.178l-13.506 13.51a2.253 2.253 0 0 1-3.178 0z"
      />
    </g>
  </svg>
);

export default FillArrowIcon;
